export default "__VITE_ASSET__V7SZyE5q__"